import { ROLE_BASED_SIGNING_ACTION_TYPE } from 'store/forms/actions';

const initialState = {};

const roleBasedSigningSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ROLE_BASED_SIGNING_ACTION_TYPE.GET_ROLE_BASED_SIGNING_SCHEMA:
      return payload;

    default:
      return state;
  }
};

export default roleBasedSigningSchemaReducer;
